import { User } from "~/entities/user/types";

const GtmIframe: React.FC<{ user: User | null; gtmID: string | undefined }> = ({
  user,
  gtmID,
}) => {
  if (user?.doNotSellMyInformation) return;
  return (
    <noscript>
      <iframe
        src={`https://www.googletagmanager.com/ns.html?id=GTM-${gtmID}`}
        height="0"
        width="0"
        style={{ display: "none", visibility: "hidden" }}
      ></iframe>
    </noscript>
  );
};

export default GtmIframe;
